export default "__VITE_ASSET__Ctvo5tmF__"